import { useCallback, useRef } from "react"
import { graphql, GraphQLSubscriptionConfig, requestSubscription } from "relay-runtime"
import {
  usePatientRecordExportRequestUpdatedSubscription as UsePatientRecordExportRequestUpdatedSubscription,
  usePatientRecordExportRequestUpdatedSubscription$data,
} from "@/modules/patients/detail/record-extract/services/__generated__/usePatientRecordExportRequestUpdatedSubscription.graphql"
import { RelayEnvironment } from "@/relay-environment"

export const patientRecordExportRequestUpdatedSubscription = graphql`
  subscription usePatientRecordExportRequestUpdatedSubscription($requestId: ID!) {
    ch_patientRecordExportRequestUpdated(requestId: $requestId) {
      id
      status
      summaryFileId
      updatedAt
      appointmentsFetched
    }
  }
`

export type PatientRecordExportRequestChange = NonNullable<
  usePatientRecordExportRequestUpdatedSubscription$data["ch_patientRecordExportRequestUpdated"]
>

const usePatientRecordExportRequestUpdatedSubscription = (
  onChange: (change: PatientRecordExportRequestChange) => void,
  onError?: () => void,
) => {
  const disposeRef = useRef<() => void>(undefined)

  const dispose = useCallback(() => {
    if (disposeRef.current) {
      disposeRef.current()
      disposeRef.current = undefined
    }
  }, [])

  const subscribe = useCallback(
    (requestId: string) => {
      dispose()

      const config: GraphQLSubscriptionConfig<UsePatientRecordExportRequestUpdatedSubscription> = {
        subscription: patientRecordExportRequestUpdatedSubscription,
        variables: { requestId },
        onNext: (data) => {
          if (data?.ch_patientRecordExportRequestUpdated) {
            onChange(data.ch_patientRecordExportRequestUpdated)
          }
        },
        onError: () => {
          onError?.()
        },
      }

      const { dispose: disposeSubscription } = requestSubscription(RelayEnvironment, config)
      disposeRef.current = disposeSubscription
    },
    [dispose, onChange, onError],
  )

  return { subscribe, dispose }
}

export { usePatientRecordExportRequestUpdatedSubscription }
